import {
	GetWorkerDocumentListResponse,
	TDocumentApplicant,
	TDocumentDefineItem,
	TDocumentFranchise,
	TDocumentLodging,
	TDocumentRecommender,
} from '@/services';

import { formatDate, getNoNumber, isJSON, map, safeJsonParse } from 'utils';

const formatFileMapper = <T>(data: T | string): Partial<T | null> => {
	return data
		? isJSON(data)
			? safeJsonParse(data as string)
			: (data as T)
		: null;
};

export const formatWorkerDocumentDetail = (
	input: GetWorkerDocumentListResponse['content'][number]
) => {
	return {
		...input,
		id: input.fileId,
		fileNo: input.no,
		fileRegistDt: formatDate(input.fileRegistDt),
		fileUpdateDt: formatDate(input.fileUpdateDt),

		fileApplicantFullName: formatFileMapper<TDocumentApplicant[]>(
			input.fileApplicantFullName
		) as TDocumentApplicant[],
		fileEmployerName: formatFileMapper<TDocumentFranchise[]>(
			input.fileEmployerName
		) as TDocumentFranchise[],
		fileLodgingAddress: formatFileMapper<TDocumentLodging[]>(
			input.fileLodgingAddress
		) as TDocumentLodging[],
		fileRecommenderName: formatFileMapper<TDocumentRecommender[]>(
			input.fileRecommenderName
		) as TDocumentRecommender[],
	};
};

export const formatWorkerDocumentList = (
	input: GetWorkerDocumentListResponse
) => ({
	...input,
	content: map(input.content, (data, index) =>
		formatWorkerDocumentDetail({ ...data, no: getNoNumber(input, index) })
	),
});

export const formatWorkerDocumentListV2 = (
	input: GetWorkerDocumentListResponse['content']
) => {
	return map(input, formatWorkerDocumentDetail);
};

export const formatDocumentDetail = (input: TDocumentDefineItem) => {
	return {
		...input,
	};
};
